<template>
  <div class="z-card z-card--small">
    <div class="z-text z-text--bold spacer-bottom-s">
      Dados do responsável financeiro
    </div>
    <div class="z-text">
      <strong>Nome:</strong> {{ studentName }}
    </div>
    <div class="z-text">
      <strong>Curso:</strong> {{ courseName }}
    </div>
    <div class="z-divider z-divider--twice spacer-st"></div>

    <template v-if="!isDischarge()">
      <div class="z-text z-text--bold spacer-bottom-s">
        Dados da mensalidade
      </div>

      <div class="z-text">
        <strong>Mensalidade referente ao mês de:</strong>
        <span>{{ bill.month_name }}</span> de {{ bill.bill_year }}
      </div>

      <div class="z-text">
        <strong>Valor da mensalidade:</strong>
        <span>{{ bill.full_value | formatCurrency }}</span>
      </div>

      <div class="z-divider z-divider--twice spacer-st"></div>
    </template>

    <div class="z-text z-text--bold spacer-bottom-s">
      Dados do pagamento
    </div>
    <div class="z-text">
      <strong>Data do pagamento:</strong> {{ bill.paid_date | formatDate }}
    </div>
    <div class="z-text">
      <strong>Valor pago:</strong> {{ bill.paid_value | formatCurrency }}
    </div>
    <div class="z-divider z-divider--twice spacer-st"></div>
    <div class="z-text z-text--bold spacer-bottom-s">
      Dados do favorecido
    </div>
    <div class="z-text">
      <strong>Favorecido:</strong> Quero Educação Serviços de Internet Ltda
    </div>

    <div class="z-text spacer-bottom-m">
      <strong>CNPJ:</strong> 10.542.212/0001-54
    </div>

    <button class="z-button z-button--secondary z-button--block" @click="downloadBillReceipt()">
      Baixar comprovante
    </button>
  </div>
</template>

<script>
import DashboardService from 'services/DashboardService';

export default {
  props: {
    courseName: {
      type: String,
      required: true,
    },
    studentName: {
      type: String,
      required: true,
    },
    bill: {
      type: Object,
      required: true,
    },
  },
  methods: {
    downloadBillReceipt() {
      this.$pageLoader.show('Baixando comprovante');
      DashboardService.downloadBillReceipt(this.bill.id).finally(() => this.$pageLoader.hide());

      this.$tracker.logEvent('Clicked Download Receipt button', { billId: this.bill.id });
    },
    isDischarge() {
      return this.bill.bill_type === 'discharge';
    },
  },
};
</script>
